<template>
  <div class="section regulatoryAffairs">
    <section class="section_slide-chart">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="chartImage" data-aos="zoom-in" data-aos-duration="1000">
              <img :src="require(`@/assets/images/svg/${this.organize.chart_image}`)" class="img-fluid" />
            </div>
            <p class="chart-text" data-aos="fade-up">{{this.organize.image_label}}</p>
          </div>
        </div>
        <div class="row justify-content-center mt-30">
          <div class="col-lg-6">
            <p data-aos="fade-up" v-for="org in this.organize.main_text" :key="org">
              {{ org }}
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Data from "./json/organizationalResponse.json";
export default {
    props:{
        organize:Object
    },
  data() {
    return {
      data: Data,
    };
  },
};
</script>

<style></style>
